import React, {Component} from 'react'
import './style.css'
import PropTypes from 'prop-types'
import {Collapse} from 'react-collapse'
import NRTButton from "../../../_common/_buttons/Button/index"
import CirclePlus from "../../../_common/_icons/CirclePlus"
import CircleMinus from "../../../_common/_icons/CircleMinus"
import CourseTrailContent from "./CourseTrailContent/index"
import Lock from "../../../_common/_icons/Lock";


export class NRTCourseTrailModule extends Component {

    state = {
        open: false,
    }


    componentDidMount() {
        this.checkModuleHasContentActive(this.props)
    }


    componentWillReceiveProps(nextProps) {
        this.checkModuleHasContentActive(nextProps)
    }


    checkModuleHasContentActive(props) {
        props.module
            .classDTOs
            .forEach(cls => {
                if (cls.contentDTOs.some(content => content.code + '' === props.activeContentId + ''))
                    this.setState({open: true})
            })
    }



    render() {
        if (!this.props.module)
            return null

        const {open} = this.state
        const {
            //id,
            module,
            activeContentId,
            concludedContents,
            inProgressContents,
            blocked,
        } = this.props

        const {
            title,
            classDTOs,
            description
        } = module


        return (

            <div className={'nrt-course-module'}>

                <NRTButton
                    secondary
                    onClick={() => this.setState({open: !open})}
                    style={{
                        width: '100%',
                        marginBottom: '.2rem',
                        opacity: blocked ? .5 : 1
                    }}
                    content={
                        <div style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
                            <div>
                                {blocked && <Lock/>}
                                <span>{title}</span>
                            </div>
                            {open ? <CircleMinus/> : <CirclePlus/>}
                        </div>
                    }

                />

                <Collapse isOpened={open}>

                    {
                        classDTOs.sort((a, b) => a.numOrder - b.numOrder).map(cls => (
                                <ul key={"cls_" + cls.code} className={'contents'}>

                                    <li className={'class-name'}>
                                        <h4>{cls.title}</h4>
                                    </li>

                                    {
                                        cls.contentDTOs.sort((a, b) => a.numOrder - b.numOrder).map(content =>
                                            (

                                                <CourseTrailContent
                                                    blocked={blocked}
                                                    key={content.code}
                                                    active={activeContentId + '' === content.code + ''}
                                                    onClick={this.props.onContentClick}
                                                    content={content}
                                                    module={module}
                                                    cls={cls}
                                                    inProgress={
                                                        inProgressContents.map(cnt => cnt.code).includes(content.code)
                                                    }
                                                    concluded={concludedContents.map(cnt => cnt.code).includes(content.code)}
                                                />
                                            )
                                        )
                                    }
                                </ul>
                            )
                        )
                    }

                </Collapse>
            </div>
        )
    }
}


NRTCourseTrailModule.propTypes = {
    blcoked: PropTypes.bool,
    activeContentId: PropTypes.number,
    onContentClick: PropTypes.func,
    module: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        classes: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string,
                name: PropTypes.string,
                contents: PropTypes.arrayOf(
                    CourseTrailContent.propTypes.content
                ),
            })
        ),
    })

}


NRTCourseTrailModule.defaultProps = {
    blcoked: false,
    open: false,
    onContentClick: () => null,
}




// WEBPACK FOOTER //
// ./src/components/_ead/CourseTrail/CourseTrailModule/index.js